const SairaAwanMalik = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]  ">
        <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex grid  lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] text-[30px] font-bold">
              Saira Awan Malik
            </h1>
            <p>President</p>
          </div>
          <div className="flex justify-end">
            <img
              src="/leadershipnew/saira_awan2.jpg"
              alt=""
              className="lg:h-[26rem] h-[17rem] leadership-images mx-[2rem] "
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="lg:text-[32px] md:text-[30px] sm:text-[30px] text-[26px] font-bold">
              Saira Awan Malik
            </h1>
            <p>President</p>
          </div>
        </div>
      </div>
      <div className="max-w-[40rem] sm:mx-auto  mx-[2rem]  my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          Saira Awan Malik is the President of the TCS Group. After training as
          a corporate lawyer, Saira worked for six years at the London office of
          international law firm Cleary Gottlieb Steen & Hamilton LLP, focusing
          on corporate and financial transactions, including cross-border
          mergers & acquisitions, restructurings and capital market issuances.
        </p>
        <p>
          Saira received an undergraduate degree in History from Yale University
          in May 1999. She read Law at the University of Cambridge (2001-3) and
          subsequently completed the Bar Vocational Course at the Inns of Court
          School of Law in London. She was called to the Bar of England and
          Wales at Lincoln’s Inn in October 2007. In 2023, Saira completed, with
          distinction, the Global Executive MBA at Columbia Business School and
          London Business School.
        </p>
        <p>
          Saira served on the board of the British Pakistan Foundation (BPF)
          from 2012-23, where she spearheaded the launch of the BPF Women’s
          Network. Saira is on the Board of the Pakistan Business Council and
          the Marketing Association of Pakistan. She is the first woman partner
          in the Champions of Change Coalition Pakistan and a member of the
          Young Presidents’ Organization Pakistan Chapter. Most recently, Saira
          joined the Board of Pakistan Cables Limited.
        </p>
      </div>
    </div>
  );
};

export default SairaAwanMalik;
